import queryString from 'query-string'

import { apiService, fetchingAPIWithPendingToken, fetchingAPI } from '@/api'
import { setMFAType, setCodeError } from '@/reducers/auth/mfa.redux'
import { updateAuthMessage } from '@/reducers/ui/ui.redux'

export const returnToLoginWithError = (errorMessage, history) => async (dispatch) => {
  dispatch(updateAuthMessage('error', errorMessage))
  history.push(`/login?keepError=1`)
}

export const enrollMFA = (mfaType, history) => async (dispatch) => {
  try {
    const response = await fetchingAPIWithPendingToken(
      `${apiService.auth}/mfa/enroll`,
      'POST',
      dispatch,
      JSON.stringify({ mfa_type: mfaType })
    )
    if (response.status !== 200) {
      throw new Error('Error enrolling MFA')
    }
    const { uri, manual_key } = await response.json()
    dispatch(setMFAType(mfaType, uri, manual_key))
  } catch (err) {
    dispatch(
      returnToLoginWithError(
        'Error enrolling in multi-factor authentication. Please try again or contact support@balto.ai',
        history
      )
    )
  }
}

export const validateMFA =
  (code, mfaType, enrolling, history, setSubmitting, next) => async (dispatch) => {
    try {
      const response = await fetchingAPIWithPendingToken(
        `${apiService.auth}/mfa/validate`,
        'POST',
        dispatch,
        JSON.stringify({ code, mfa_type: mfaType, enrolling })
      )

      // on success, redirect to login with token
      if (response.status === 200) {
        const { token } = await response.json()
        history.push(`/login?${queryString.stringify({ token, next })}`)
        return
      }

      // on 400 user can still retry (will get 401 on invalid code when retries exhausted)
      if (response.status === 400) {
        dispatch(setCodeError(true))
        setSubmitting(false) // allow the form to be submitted again
        return
      }

      throw new Error('Error validating MFA')
    } catch (err) {
      dispatch(
        returnToLoginWithError(
          'Error signing in with multi-factor authentication. Please try again or contact support@balto.ai',
          history
        )
      )
    }
  }

export const resendMFAEmail = (history) => async (dispatch) => {
  try {
    const response = await fetchingAPIWithPendingToken(
      `${apiService.auth}/mfa/resend_email`,
      'POST',
      dispatch
    )
    if (response.status !== 200) {
      throw new Error('Error resending MFA email')
    }
  } catch (err) {
    dispatch(
      returnToLoginWithError(
        'Error sending multi-factor authentication email. Please try again or contact support@balto.ai',
        history
      )
    )
  }
}

export const resetUserMFAConfig = (userID) => async (dispatch) => {
  await fetchingAPI(`${apiService.auth}/mfa/reset_user/${userID}`, 'DELETE', dispatch)
}
